import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'dark' | 'light';

const SESSION_DURATION_MS = 8 * 60 * 60 * 1000; // 8 hours

type Store = {
  theme: Theme;
  isSidebarCollapsed: boolean;
  user: string | null;
  sessionExpiry: number | null;
  toggleTheme: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  login: (username: string) => void;
  logout: () => void;
};

/**
 * Global application store.
 * Use React Query for server state — Zustand is for client-only UI state.
 */
export const useStore = create<Store>()(
  persist(
    (set) => ({
      theme: 'dark',
      isSidebarCollapsed: false,
      user: null,
      sessionExpiry: null,
      toggleTheme: () =>
        set((state) => ({
          theme: state.theme === 'dark' ? 'light' : 'dark',
        })),
      setSidebarCollapsed: (collapsed: boolean) => set(() => ({ isSidebarCollapsed: collapsed })),
      login: (username: string) =>
        set(() => ({
          user: username,
          sessionExpiry: Date.now() + SESSION_DURATION_MS,
        })),
      logout: () => set(() => ({ user: null, sessionExpiry: null })),
    }),
    { name: 'et-store' }
  )
);

export const getStoreState = () => useStore.getState();
